import React, {useRef, useState} from "react";
import {
    TextField,
    Typography,
    Button,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import {Link, useNavigate} from "react-router-dom";
import { useSnackbar } from "notistack";
import LoadingButton from "../../../../components/elements/LoadingButton";
import axios from "axios";
import { defaultVariables } from "../../../../../config";
import Grid from "@mui/material/Grid2";
import validator from 'validator';
import {useTranslation} from "react-i18next";
import CountryCodeChooser from "../../../../components/elements/fields/CountryCodeChooser";
import MobileField from "../../../../components/elements/fields/MobileField";
import {Mail} from "lucide-react";


const ChooseMobile = ({ setUser, setNextLevel, hasBack, iframe }) => {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation();
    const inputRef = useRef(null);
    const [fields, setFields] = useState({ mobile: "",country:null });
    const [errors, setErrors] = useState({});
    const [submitLoading, setSubmitLoading] = useState(false);

    const setMobile = (country,mobile) => {
        setFields({
            country,
            mobile
        })
        setErrors({});
    }

    const validateFields = () => {
        const newErrors = {};
        let formIsValid = true;

        if (!validator.isNumeric(fields.mobile) || fields.mobile.length < 9) {
            formIsValid = false;
            newErrors.mobile = t("wrongMobile");
        }

        setErrors(newErrors);
        return formIsValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitLoading(true);

        if (!validateFields()) {
            setSubmitLoading(false);
            return;
        }

        const data = new FormData();
         let mobile = Number(fields.mobile).toString();
        mobile = fields.country?.phonecode+mobile;
        data.append("mobile", mobile);
        data.append("code", fields.country?.phonecode);

        try {
            const response =  await axios.post(
                `${defaultVariables.url}/auth/set-user`,
                data,
                { headers: { Accept: "application/json" } }
            );
            await setUser(response.data);
            await setNextLevel();
        } catch (error) {
            enqueueSnackbar(t("wrongMobile"), { variant: "error" });
            console.error(error.response);
        } finally {
            setSubmitLoading(false);
        }
    };

    return (
        <form  noValidate onSubmit={handleSubmit}>
            <Grid container spacing={2} justifyContent="center" alignItems="center">
                <Grid item size={12}>
                    <MobileField
                        setMobile={setMobile}
                        error={errors['mobile']}
                    />
                </Grid>
                <Grid item size={12}>
                    <LoadingButton
                        type="submit"
                        variant="contained"
                        color="primary"
                        size="large"
                        fullWidth
                        loading={submitLoading}
                        style={{width:"100%"}}
                        styleForParent={{margin:"10px 0"}}
                    >
                        {t("continue")}
                    </LoadingButton>
                </Grid>
                <Grid item size={12} style={{textAlign:"center"}}>
                    <Button
                        color="secondary"
                        component={Link}
                        to={'/email-login'}
                        startIcon={<Mail className="lucide-icon"/>}
                    >
                        {t('loginWithEmail')}
                    </Button>
                </Grid>
            </Grid>
        </form>
    );
};

export default ChooseMobile;
